package nl.astraeus.wiki.view

import kotlinx.html.div
import kotlinx.html.h1
import kotlinx.html.input
import kotlinx.html.js.onClickFunction
import kotlinx.html.js.onFocusOutFunction
import kotlinx.html.org.w3c.dom.events.Event
import kotlinx.html.title
import nl.astraeus.css.properties.*
import nl.astraeus.komp.HtmlBuilder
import nl.astraeus.komp.Komponent
import nl.astraeus.komp.currentElement
import nl.astraeus.wiki.WikiData.currentWiki
import nl.astraeus.wiki.WikiData.wikiList
import nl.astraeus.wiki.css.Css.defineCss
import nl.astraeus.wiki.css.CssName
import nl.astraeus.wiki.mainView
import nl.astraeus.wiki.messages.MessageType
import nl.astraeus.wiki.messages.UpdateWikiTitleMessage
import nl.astraeus.wiki.service.UserService
import nl.astraeus.wiki.service.WikiService
import nl.astraeus.wiki.ws.sendMessage
import org.w3c.dom.HTMLInputElement

class Header : Komponent(), CssName {
  private object HeaderHeaderCss : CssName
  private object HeaderTitleInputCss : CssName

  init {
    defineCss {
      select(HeaderTitleInputCss.cls()) {
        fontSize(28.px)
        border("none")
        outline("none")
        backgroundColor(hsl(60, 50, 90))
        padding(0.5.rem)
        position(Position.relative)
        top((-0.5).rem)
      }
      select(HeaderHeaderCss.cls()) {
        display(Display.flex)
        flexDirection(FlexDirection.row)
        justifyContent(JustifyContent.spaceBetween)
      }
    }
  }

  var editingTitle = false

  fun titleClick(e: Event) {
    editingTitle = true
    requestUpdate()
  }

  fun titleSave(e: Event) {
    editingTitle = false
    val target = e.target

    if (target is HTMLInputElement) {
      currentWiki?.also { cw ->
        sendMessage(UpdateWikiTitleMessage(cw.id, target.value)) { msg ->
          if (msg.getMessageType() == MessageType.SUCCESS) {
            for (wiki in wikiList) {
              if (wiki.id == cw.id) {
                wiki.title = target.value
              }
            }
            cw.title = target.value
            requestUpdate()
          }
        }
      }
    }
  }

  override fun HtmlBuilder.render() {
    div(HeaderHeaderCss.name) {
      h1 {
        if (editingTitle) {
          input(classes = HeaderTitleInputCss.name) {
            value = currentWiki?.title ?: ""

            onFocusOutFunction = ::titleSave

            (currentElement() as? HTMLInputElement)?.focus()
          }
        } else {
          +(currentWiki?.title ?: "")

          if (UserService.loggedIn) {
            title = "Click on title to change"

            onClickFunction = ::titleClick
          }
        }

      }
      div("${MainView.AddCss.name} ${MainView.HeaderButtonCss.name}") {
        +"Back to all wiki's"

        onClickFunction = {
          currentWiki = null

          WikiService.retrieveWikiList()
          mainView.requestUpdate()
        }
      }
    }
  }
}
